import { RouteObject } from "react-router-dom";
import Home from "@/pages/Home/Home";
import Gallery from "@/pages/Gallery/Gallery";
import About from "@/pages/About/About";
import Contact from "@/pages/Contact/Contact";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
